import { jsx as _jsx } from "react/jsx-runtime";
import { useTestId } from "@/hooks";
import { Box } from "@gemini/core";
import { useHardFacts } from "@/contexts/classified";
export const PriceInformations = () => {
    var _a;
    const testId = useTestId("Sections.Hardfacts.Price.Informations");
    const { additionalInformation } = ((_a = useHardFacts()) === null || _a === void 0 ? void 0 : _a.price) || {};
    return additionalInformation ? (_jsx(Box, { as: "span", typography: "typography.body.14.regular", color: "color.content.light.default", testId: testId, children: additionalInformation })) : null;
};
